







































import { Vue, Component, Prop } from 'vue-property-decorator'
import { StudyDummyBaseMethod } from '@/mixins/requests/student/StudyApis.vue'
import { QuestionAnswerType } from '@/mixins/requests/student/StudyApis.vue'

@Component({})
export default class StudyDummy1 extends Vue implements StudyDummyBaseMethod {
  @Prop()
  currentQuestionAnswer?: QuestionAnswerType

  public getQuestionAnswer(): QuestionAnswerType {
    // 入力値を取得
    let checkValue = ''
    let nodeList: NodeList = document.getElementsByName('check')
    if (nodeList) {
      for (let i = 0; i < nodeList.length; i++) {
        let node: Node = nodeList[i]
        if (node.nodeType == Node.ELEMENT_NODE) {
          let element = node as HTMLInputElement
          if (element.checked) {
            checkValue = element.value
          }
        }
      }
    }
    return { inputs: [checkValue] }
  }

  public restoreInputedElements(): void {
    // 入力値を復元
    if (!this.currentQuestionAnswer || !this.currentQuestionAnswer.inputs) return
    const value = this.currentQuestionAnswer.inputs[0]
    console.log(value)
    if (!value) return
    let element = document.getElementById(`check${Number(value)}`) as HTMLInputElement
    if (element) element.checked = true
  }

  public clearInputedElements(): void {
    // やり直し
    let nodeList: NodeList = document.getElementsByName('check')
    if (nodeList) {
      for (let i = 0; i < nodeList.length; i++) {
        let node: Node = nodeList[i]
        if (node.nodeType == Node.ELEMENT_NODE) {
          let element = node as HTMLInputElement
          element.checked = false
        }
      }
    }
  }

  private mounted() {
    // 入力値を復元
    this.restoreInputedElements()
  }
}
